import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CarouselModule } from "ngx-owl-carousel-o";
import { TranslateModule } from "@ngx-translate/core";
import {
  NgbNavModule,
  NgbRatingModule,
} from "@ng-bootstrap/ng-bootstrap";
import { AccordionModule } from "primeng/accordion";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { YouTubePlayerModule } from "@angular/youtube-player";

import { HomeRoutingModule } from "./home-routing.module";
import { HomeComponent } from "./home.component";
import { SharedModule } from "src/app/hanbee3-admin/shared/shared.module";

@NgModule({
  declarations: [HomeComponent],
  imports: [
    CommonModule,
    HomeRoutingModule,
    TranslateModule,
    AccordionModule,
    CarouselModule,
    NgbNavModule,
    YouTubePlayerModule,
    NgxSkeletonLoaderModule,
    NgbRatingModule,
    SharedModule
  ]
})
export class HomeModule {}
